import { tradeAccuracy } from "@/utils/common";
import { txEvm } from "../../config/apiServe/new-rpc";
import { getTransactionAnalysis } from '../../config/apiServe/scanner'
export default {
    data() {
        return {
            hash: "",
            txNotFound: false,
            trade: {
                state: "",
                tx: {},
            },
            erc20Tokens: [],
            markdownTxt: "",
        };
    },
    watch: {
        $route() {
            this.init();
        },
    },
    mounted() {
        this.init();
        this._getTransactionAnalysis(this.hash);
    },
    methods: {
        init() {
            if (this.$route.params.hash) {
                this.hash = this.$route.params.hash;
                this.getTradeDetail(this.hash);
            } else {
                this.$notify({
                    title: this.$t("components.tip"),
                    message: this.$t("components.errParam"),
                    type: "warning",
                    duration: 1000,
                });
                this.$router.push({
                    path: "/",
                });
            }
        },
        getTradeDetail(hash) {
            this.Rpc.queryTransaction(hash).then(async (data) => {
                if (!data.result) {
                    // 未查询到交易信息
                    this.txNotFound = true;
                    return;
                }
                this.trade = data.result;
                if (
                    tradeAccuracy(
                        data.result.tx.execer,
                        data.result.receipt.ty,
                        this.$store.getters.isParallelChain
                    )
                ) {
                    this.trade.state = 2;
                    this.trade.txt = this.$store.getters.isParallelChain
                        ? this.$t("txDetail.faild")
                        : this.$t("components.fail");
                } else {
                    this.trade.state = 1;
                    this.trade.txt = this.$store.getters.isParallelChain
                        ? this.$t("txDetail.success")
                        : this.$t("components.succ");
                }
                // data.result.tx.nonce = data.result.tx.nonce.toString();
                // this.tradehInfoTx = data.result.tx;
                if (this.trade.tx.execer == "user.write") {
                    this.markdownTxt = this.trade.tx.payload.content;
                    this.$forceUpdate();
                }
                if (
                    this.trade.tx.execer == "evm" ||
                    this.trade.tx.execer.slice(-4) == ".evm"
                ) {
                    const { result } = await txEvm(this.trade.tx.hash);
                    this.trade.amount = result.Amount;
                    this.trade.assets = [result.Asset];
                    this.trade.chainHash = result.Chain33TxId
                    this.trade.evmHash = result.EvmTxId
                    console.log(this.trade);
                }
            });
        },
        _getTransactionAnalysis(hash) {
            getTransactionAnalysis(hash).then(res => {
                this.erc20Tokens = res.data;
            })
        },
        success() {
            this.$message.success(this.$t("components.copySuc"));
        },
        error() {
            this.$message.warning(this.$t("components.copyErr"));
        },
    },
};
